import {getCurrentInstance, inject, unref, normalizeClass} from 'vue';

export type UKey = number | string;
const DataSourceMetadataKey = Symbol();

export const DataSourceStatus = {
    FOUND: 200,
    NOT_FOUND: 404,
    EMPTY: 204,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_ALLOWED: 405,
    NOT_IMPLEMENTED: 501,
    UNAVAILABLE: 503,
    TIMEDOUT: 504,
    INTERNAL_ERROR: 500
};

export class DataSourceError extends Error {
    constructor(status: number) {
        super(Object.keys(DataSourceStatus)[Object.values(DataSourceStatus).indexOf(status)]);
    }
}
export interface IDataSource<T> {}
export interface ICrudDataSource<T> extends IDataSource<T> {
    create(...args: any[]): Promise<T | any>;
    get(...args: any[]): Promise<T | any>;
    remove(...args: any[]): Promise<boolean | any>;
    list(...args: any[]): Promise<T[] | any>;
    update(...args: any[]): Promise<T | any>;
}

export class DataSource<T> implements IDataSource<T> {
    constructor(protected recordClass: {new (): T}) {}
}
/**
 * Construct provided data source
 * @param dataSource DataSource
 * @param recordClass
 * @param args to pass to the DataSource constructor
 * @returns
 */

export function useDataSource<R extends IDataSource<T>, T>(
    resourceClass: {new (...args: any[]): R},
    recordClass: {new (...args: any[]): T},
    ...args: any[]
): any {
    // FIXME после обновления TS типизация :R перестала работать
    if (!getCurrentInstance()) {
        return Reflect.construct(resourceClass, [recordClass, ...args]) as R;
    }
    return Reflect.construct(inject(resourceClass.name), [recordClass, ...args]) as R;
}

export function setMetadata<T>(obj: T, data: any): T {
    obj[DataSourceMetadataKey] = data;
    return obj;
}

export function getMetadata<T>(obj: any): T {
    return unref(obj)[DataSourceMetadataKey];
}
